<template>
  <section class="job-status apply-form">
    <div class="job-status__wrapper">
      <transition name="fade" mode="out-in">
        <div
          v-if="isLoading"
          key="loading"
          class="content-box content-box__color-secondary job-status__card text-center"
        >
          <v-progress-linear
            class="mb-6"
            indeterminate
            rounded
            color="primary"
            height="10"
          />
          <p class="mb-0">{{ $t('jobStatus.loading') }}</p>
        </div>

        <div
          v-else-if="loadFailed"
          key="error"
          class="content-box job-status__card job-status__card--error text-center"
        >
          <v-icon color="error" size="64" class="mb-4">mdi-alert-circle</v-icon>
          <h2 class="job-status__title">{{ $t('jobStatus.errorTitle') }}</h2>
          <p class="job-status__description">
            {{ $t('jobStatus.errorDescription') }}
          </p>
        </div>

        <div
          v-else
          key="status"
          class="content-box content-box__color-secondary job-status__card"
        >
          <h2 class="job-status__eyebrow">
            <v-icon color="primary" size="48">
              mdi-clipboard-text-outline
            </v-icon>
            {{ $t('jobStatus.currentStatus') }}
          </h2>
          <p class="job-status__description">
            {{ $t('jobStatus.description1') }}
          </p>
          <h3 class="job-status__title">{{ localize(jobTitle) }}</h3>
          <p class="job-status__description">
            {{ $t('jobStatus.description2') }}
          </p>
          <h3 class="job-status__title">{{ statusText }}</h3>
          <div class="job-status__actions">
            <v-btn color="primary" large :to="jobsLink">
              {{ $t('jobStatus.backToJobs') }}
            </v-btn>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data: () => ({
    statusLabel: '',
    jobTitle: '',
    isLoading: true,
    loadFailed: false
  }),

  watch: {
    async $route() {
      await this.initialize();
    }
  },

  computed: {
    statusText() {
      if (!this.statusLabel) {
        return '';
      }

      return this.localize(this.statusLabel);
    },

    jobsLink() {
      const slug = this.$route.params.slug;
      if (!slug) {
        return '/';
      }

      return {
        name: 'jobs',
        params: { slug }
      };
    },

    jobId() {
      return this.$route.params.jobId;
    },

    identifier() {
      return this.$route.params.identifier;
    }
  },

  async mounted() {
    await this.initialize();
  },

  methods: {
    ...mapActions('jobsModule', {
      getJobStatus: 'loadJobStatus'
    }),

    async initialize() {
      this.isLoading = true;
      this.loadFailed = false;

      try {
        const jobId = this.$route.params.jobId;
        const identifier = this.$route.params.identifier;
        const token = this.$route.params.token;

        if (!jobId || !identifier || !token) {
          throw new Error('Missing route params for job status view.');
        }

        const response = await this.getJobStatus({
          jobofferId: jobId,
          identifier,
          token
        });

        this.statusLabel = response.statusLabel;
        this.jobTitle = response.jobTitle;
      } catch (error) {
        console.error('Failed to load job status', error);
        this.statusLabel = null;
        this.loadFailed = true;
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.job-status {
  display: flex;
  justify-content: center;

  &__wrapper {
    width: 100%;
  }

  &__actions {
    display: flex;
    justify-content: flex-start;
  }

  &__title {
    white-space: normal;
    word-break: normal;
    overflow-wrap: normal;
    hyphens: manual;
  }
}

@media only screen and (max-width: 599px) {
  .job-status {
    &__meta {
      flex-direction: column;
      gap: 12px;
    }
  }
}
</style>
